/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsChangeInvestorCreditSplit204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsChangeInvestorCreditSplit505Schema = z.any();

export const optionsChangeInvestorCreditSplitMutationResponseSchema = z.lazy(
  () => optionsChangeInvestorCreditSplit204Schema
);
